import { FC } from 'react';
import cn from 'classnames';

import biasesLogoDescription from '@data/biasesLogoDescription';

import InstagramLogo from '@icons/InstagramLogo';
import TiktokLogo from '@icons/TiktokLogo';
import XLogo from '@icons/XLogo';

import styles from './Logos.module.scss';

type LogoProps = {
  className?: string;
};
const Logos: FC<LogoProps> = ({ className }) => {
  const description = biasesLogoDescription.en.description;

  return (
    <div
      className={cn(styles.logoWrapper, {
        [className]: !!className,
      })}
    >
      <span className={styles.title}>{description}</span>
      <div className={styles.flexWrapper}>
        <div className={styles.flex}>
          <InstagramLogo />
          <XLogo />
          <TiktokLogo />
        </div>
      </div>
    </div>
  );
};
export default Logos;
